import { useQuery } from "@tanstack/react-query"
import { getBackofficeReferralsQuery } from "modules/backoffice/lib/referrals/getBackofficeReferralsQuery"

export function useGetBackofficeReferralsQuery(
  ...args: Parameters<typeof getBackofficeReferralsQuery>
) {
  return useQuery(getBackofficeReferralsQuery(...args))
}
